/*@ngInject*/
export default function run($rootScope, $location, $cookies, $templateCache){
    $rootScope.$on('$routeChangeStart', function (event, next) {
        if (next.access !== undefined){
            if (next.access.requiresLogin){
                if ($cookies.getObject('user') === undefined){
                    $location.path('login');
                }

            }
        }
    });
}